import { useCallback } from "react";
import { CHATBOT_ENABLE_LOCALES } from "./config";
export function useEHChatBotVisibility() {
    const shouldRenderChatBot = useCallback((locale) => {
        return CHATBOT_ENABLE_LOCALES.indexOf(locale) !== -1;
    }, []);
    const shouldRenderBanner = useCallback((locale) => {
        return shouldRenderChatBot(locale);
    }, [shouldRenderChatBot]);
    return { shouldRenderChatBot, shouldRenderBanner };
}
